import RegionList from './regions.list';

export const RegionStores = {
  list: RegionList,
};
